import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadow.z5};
  cursor: pointer;
  display: flex;
  background-color: ${({ theme }) => theme.colors.text.title};
  border-radius: ${({ theme }) => theme.radius.s400};
  height: 44px;
  justify-content: center;
  margin-top: ${({ theme }) => theme.space.s100};
  width: 44px;

  svg {
    display: block;

    path {
      fill: ${({ theme }) => theme.colors.white.s100}
    }
  }
`

Wrapper.displayName = 'SearchButtonWrapper'
